import React from 'react';
import { Link } from 'react-router-dom';

const Condition = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Terms & Conditions</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      {/* --- MAIN CONTENT --- */}
      <section className="terms-section">
        <div className="container">
          <div className="row justify-content-center">
            
            <div className="col-lg-12">
              <div className="terms-card">
                
                {/* Intro Header */}
                 <div className=" mb-5 text-center">
            <span className="heading-subtitle wow fadeInUp animated">⭐ Terms of Service Agreement</span>
            <h2 className="wow fadeInUp animated">Please review these Terms & Conditions before proceeding</h2>
                  
                  <div className="acceptance-box">
                    <i className="flaticon-check"></i>
                    <p>By clicking <strong>“I Agree”</strong> or using our services, you accept these Terms. If you do not agree, please stop using the Website, App, and Services immediately.</p>
                  </div>
                  
                  <p className="mt-3 text-muted">
                    This Agreement is between <strong>Wall Street Merchants Pvt Ltd</strong> and <strong>You</strong> (the user).
                  </p>
                </div>

                <hr className="divider" />

                {/* 1. Definitions */}
                <div className="term-block">
                  <h3>1. Definitions (Simplified)</h3>
                  <div className="definition-grid">
                    <div className="def-item">
                      <strong>Application / App</strong>
                      <p>Digital platform offered by Wall Street Finz.</p>
                    </div>
                    <div className="def-item">
                      <strong>Lender</strong>
                      <p>Company and its lending partners (NBFCs/Banks).</p>
                    </div>
                    <div className="def-item">
                      <strong>Loan</strong>
                      <p>Short-term financial assistance applied for via our Platform.</p>
                    </div>
                    <div className="def-item">
                      <strong>User Data</strong>
                      <p>Information, documents, and details submitted by you.</p>
                    </div>
                  </div>
                </div>

                {/* 2. Services */}
                <div className="term-block">
                  <h3>2. Services & User Obligations</h3>
                  <p>By using our Services, you allow the Company to:</p>
                  <ul className="check-list-blue">
                    <li>Collect, verify, and process your data.</li>
                    <li>Access and validate your documents for loan approval.</li>
                    <li>Retrieve credit information from authorised bureaus.</li>
                    <li>Track your location until all dues are cleared.</li>
                  </ul>
                  
                  <div className="info-note mt-3">
                    <strong>Process:</strong> You must register and submit KYC details. Once verified, loans may be approved. Disbursement happens only after mandatory forms (ECS/NACH) are completed. You must repay on the due date.
                  </div>
                </div>

                {/* 3. Restrictions */}
                <div className="term-block">
                  <h3>3. Restrictions</h3>
                  <div className="restriction-box">
                    <div className="res-icon"><i className="flaticon-forbidden"></i></div>
                    <div className="res-content">
                      <p><strong>You must NOT:</strong></p>
                      <ul>
                        <li>Misuse the Platform or submit fraudulent information.</li>
                        <li>Upload harmful, illegal, abusive, or offensive content.</li>
                        <li>Spread viruses, spam, or malicious software.</li>
                        <li>Violate laws or disrupt the Platform in any way.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* 4. Disclaimers & Liability */}
                <div className="term-block">
                  <h3>4. Disclaimers & Liability</h3>
                  
                  <div className="legal-accordion">
                    <div className="legal-item">
                      <h5>Disclaimer of Warranties</h5>
                      <p>Services are provided “as is”. We do not guarantee error-free service, continuous access, or accuracy of results. You use the Platform at your own risk.</p>
                    </div>
                    <div className="legal-item">
                      <h5>Limitation of Liability</h5>
                      <p>The Company is not liable for direct/indirect damages, loss of data, system issues, device harm, or service delays.</p>
                    </div>
                    <div className="legal-item">
                      <h5>Force Majeure</h5>
                      <p>We are not responsible for service failures due to events beyond control (internet issues, government actions, natural disasters, etc.).</p>
                    </div>
                    <div className="legal-item">
                      <h5>Third-Party Links</h5>
                      <p>External links or ads are not endorsed by Wall Street Finz. Interaction is solely your responsibility.</p>
                    </div>
                  </div>
                </div>

                {/* 5. Refund Policy */}
                <div className="term-block">
                  <h3>5. Cancellation & Refund Policy</h3>
                  <div className="refund-container">
                    <div className="refund-step">
                      <span className="badge-step">1</span>
                      <strong>Before Disbursement</strong>
                      <p>Cancellation is allowed.</p>
                    </div>
                    <div className="refund-step">
                      <span className="badge-step">2</span>
                      <strong>After Disbursement</strong>
                      <p>Cancel within 24 hours by repaying the principal.</p>
                    </div>
                    <div className="refund-step">
                      <span className="badge-step">3</span>
                      <strong>Excess Payments</strong>
                      <p>Refunded within 5–7 working days.</p>
                    </div>
                  </div>
                </div>

                {/* 6. Miscellaneous */}
                <div className="term-block">
                  <h3>6. Miscellaneous</h3>
                  <ul className="dot-list">
                    <li><strong>Privacy Policy:</strong> We collect/process data as per our Privacy Policy. Using services means you consent.</li>
                    <li><strong>Changes:</strong> Terms may be updated anytime. Continued use = acceptance.</li>
                    <li><strong>Governing Law:</strong> All disputes fall under the jurisdiction of <strong>Gurugram, Haryana, India.</strong></li>
                    <li><strong>Agreement:</strong> These Terms, Loan Agreement, App Form, and Privacy Policy form the complete agreement.</li>
                  </ul>
                </div>

                {/* Contact Footer */}
                <div className="contact-box-terms">
                  <h4>Contact for Violations or Queries</h4>
                  <p>For concerns regarding these Terms, contact:</p>
                  <div className="contact-details">
                    <div className="contact-row">
                        <i className="flaticon-email"></i>
                        <a href="mailto:info@wallstreetfinz.com">info@wallstreetfinz.com</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Condition;